import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { ServicePlan } from 'src/features/servicePlans/utils/types';
import DeleteServicePlanFormModal from 'src/features/servicePlans/components/forms/DeleteServicePlanFormModal';
import UpdateServicePlanFormModal from '../forms/UpdateServicePlanFormModal';
import { servicePlansMessages } from 'src/features/servicePlans/utils/messages';
import { Link } from 'react-router-dom';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellServicePlanActions({ row }: CellContext<ServicePlan, unknown>) {
    const { formatMessage } = useIntl();
    const permissionManageServicePlans = useHasPermissions([PERMISSION.MANAGE_SERVICE_PLANS]);

    const planActiveStatus = row.original.is_active;

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/service-plans/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManageServicePlans && (
                    <>
                        <Tooltip>
                            <UpdateServicePlanFormModal
                                semantics={{ entryName: formatMessage(servicePlansMessages.plan).toLowerCase() }}
                                selectedServicePlan={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateServicePlanFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        {!planActiveStatus && (
                            <Tooltip>
                                <DeleteServicePlanFormModal selectedServicePlan={row.original}>
                                    <TooltipTrigger asChild>
                                        <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                            <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                        </Button>
                                    </TooltipTrigger>
                                </DeleteServicePlanFormModal>
                                <TooltipContent>
                                    <FormattedMessage {...generalMessages.delete} />
                                </TooltipContent>
                            </Tooltip>
                        )}
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
